<mat-card class="announcement__style" *ngIf="post">
    <mat-card-header>
        <img mat-card-avatar *ngIf="postParticipant.avatarBase64" [src]="'data:image/jpg;base64,'+ postParticipant.avatarBase64 | safeHtml">
        <mat-icon mat-card-avatar *ngIf="!postParticipant.avatarBase64">account_circle</mat-icon> 
        <!-- <mat-icon mat-card-avatar *ngIf="!post.profilePhoto">fiber_manual_record</mat-icon> -->
        <mat-card-title>{{post?.authorName}}</mat-card-title>
        <mat-card-subtitle class="annoucement__subtitle">
            <span class="date__style">{{postDate | date:'MMM dd - hh:mm a' }}</span>
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        <mat-card-title>{{post.title}}</mat-card-title>
        <span *ngFor="let postContent of post.content">
            <img mat-card-image *ngIf="postContent.binaryContentBase64" [src]="'data:image/jpg;base64,'+ postContent.binaryContentBase64 | safeHtml" >
            <p>{{postContent.textContnet}}</p>
        </span>
        
    </mat-card-content>
</mat-card>